import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
//import {auth} from '../../Firebase/Utility'
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Link from "@material-ui/core/Link"
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { Button } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));

export default function AppMenu({isLoggedIn, logout}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton  onClick={handleClick} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon/>
          </IconButton>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleClose}><Link  color="inherit" href='/dashboard' underline="none">Dashboard</Link></MenuItem>
        <MenuItem onClick={handleClose}><Link  color="inherit" href='/senate' underline="none">Senate</Link></MenuItem>
        <MenuItem onClick={handleClose}><Link color="inherit" href='/executives' underline="none">Executives</Link></MenuItem>
        <MenuItem onClick={handleClose}><Link color="inherit" href='/electionresultsreal' underline="none">Results</Link></MenuItem>
        {isLoggedIn ?<MenuItem onClick={logout}>Logout</MenuItem>: <MenuItem ><Link color="inherit" underline="none"  href ="/login">Login</Link></MenuItem>}
      </Menu>
    </div>
  );
}
